import React from "react";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import i18n from "i18next";
import { createRoot } from "react-dom/client";
import { initReactI18next } from "react-i18next";
import { BrowserRouter } from "react-router-dom-v5-compat";

import onsite_au from "../../frontend/onsite_app/locales/en-AU.json";
import onsite_gb from "../../frontend/onsite_app/locales/en-GB.json";
import onsite_nz from "../../frontend/onsite_app/locales/en-NZ.json";
import onsite from "../../frontend/onsite_app/locales/en.json";
import App from "../onsite_app";
import "../styles/Onsite.css";

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    debug: true,
    resources: {
      en: { translations: onsite },
      "en-NZ": { translations: onsite_nz },
      "en-AU": { translations: onsite_au },
      "en-GB": { translations: onsite_gb },
    },
    lng: "en",
    fallbackLng: "en",
    defaultNS: "translations",
    ns: "translations",
  });

const queryClient = new QueryClient();
document.addEventListener("DOMContentLoaded", () => {
  const baseRoute = (window as { baseRoute?: string }).baseRoute;
  const container = document.getElementById("App");
  const root = createRoot(container!);
  root.render(
    <QueryClientProvider client={queryClient}>
      <App />
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>,
  );
});
